import request from './request'

// 获取详情
export function getZGInfo (data) {
  return request.get('en/zoneAndGroup/getZGInfo', data)
}
// 更新，新增
export function operateZGInfo (data) {
  return request.post('en/zoneAndGroup/operateZGInfo', data, 'json')
}
// 删除
export function deleteZGInfo (data) {
  return request.post('en/zoneAndGroup/deleteZGInfo', data)
}
